<p *ngIf="hasError(name)" class="u-text--sm u-text--error">
	<ng-content></ng-content>
</p>
